import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { trackFaqOpen } from "@/lib/analytics";

export default function FaqAccordion({ items, idPrefix = "faq" }) {
  const onChange = (value) => {
    if (!value) return;
    const idx = Number(value.split("-").pop());
    const item = items[idx];
    if (item) trackFaqOpen(item.q);
  };

  return (
    <Accordion type="single" collapsible className="w-full" onValueChange={onChange}>
      {items.map((it, i) => (
        <AccordionItem
          key={i}
          value={`${idPrefix}-${i}`}
          className="border-b border-etap-deep-100"
          data-testid={`${idPrefix}-item-${i}`}
        >
          <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-etap-deep-800 hover:no-underline [&[data-state=open]>svg]:text-etap-primary">
            {it.q}
          </AccordionTrigger>
          <AccordionContent className="pb-5 pr-6 text-[15px] leading-relaxed text-etap-deep-600">
            {it.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
